import { linkifyHtml } from '../utils/linkify';
import DOMPurify from 'dompurify';

import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useContent } from '../hooks/useContent';
import { useSeo } from '../hooks/useSeo';
import { AdminControls } from '../components/AdminControls';
import type { PageContent } from '../types';
import { useToast } from '../hooks/useToast';

export const TermsPage: React.FC = () => {
  const navigate = useNavigate();
  const { content: allContent, isAdminMode, updatePageContent } = useContent();
  const [pageContent, setPageContent] = useState<PageContent>(allContent.terms);
  const { showToast } = useToast();
  
  const onSeoApplied = useCallback(() => {
    window.dispatchEvent(new Event('app-rendered'));
  }, []);

  useSeo(pageContent, 'terms', onSeoApplied);

  useEffect(() => {
    setPageContent(allContent.terms);
  }, [allContent.terms]);

  const handleSave = async () => {
    const oldSlug = allContent.terms?.seo?.slug;
    const redirectCreated = await updatePageContent('terms', pageContent);
    showToast('Terms page content saved!');
    if (redirectCreated) {
      const newSlug = pageContent.seo.slug;
      showToast(`Redirect created: ${oldSlug} -> ${newSlug}`);
    }
  };

  const sanitizedBody = pageContent?.body ? linkifyHtml(pageContent.body) : '';

  return (
    <div className="w-full max-w-6xl mx-auto py-8 md:py-12 px-4 sm:px-6 lg:px-8 text-[#1F2937]">
      <div className="w-full max-w-3xl mx-auto">
        <header className="text-center mb-10">
          <h1 className="text-3xl md:text-4xl font-bold text-[#4F46E5]">
            {pageContent.h1}
          </h1>
        </header>

        <div className="bg-white shadow-lg rounded-xl p-6 md:p-8 border border-gray-200">
           <div 
            className="prose max-w-none"
            dangerouslySetInnerHTML={{ __html: sanitizedBody }} 
          />
          
           {isAdminMode && (
              <AdminControls 
                  pageId="terms" 
                  pageContent={pageContent} 
                  onContentChange={setPageContent}
                  onSave={handleSave}
              />
          )}
          
          <div className="text-center pt-6">
            <button
              onClick={() => navigate('/')}
              className="inline-block py-3 px-8 bg-[#4F46E5] hover:bg-[#6366F1] text-white font-bold rounded-lg shadow-md transition-all duration-300"
            >
              Go to Brand Name Generator
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
